import { render } from "./InputMenu.vue?vue&type=template&id=70373e1a"
import script from "./InputMenu.vue?vue&type=script&lang=js"
export * from "./InputMenu.vue?vue&type=script&lang=js"
script.render = render

export default script